import React, { useState, ChangeEvent } from 'react';
import { Form, Col } from 'react-bootstrap';

interface ColorPickerProps {
  label: string; // --- ADICIONADO: Prop para o título ---
  onColorChange: (color: string) => void;
  initialColor?: string;
}

const ColorPicker: React.FC<ColorPickerProps> = ({ 
  label, // --- ADICIONADO ---
  onColorChange,
  initialColor = '#000000' 
}) => {
  const [selectedColor, setSelectedColor] = useState<string>(initialColor);

  const handleColorChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newColor = e.target.value;
    setSelectedColor(newColor);
    onColorChange(newColor); 
  };

  return (

    <>
      <Form.Label>{label}</Form.Label>
      <Form.Control 
        type="color"
        value={selectedColor}
        title="Escolha sua cor"
        onChange={handleColorChange}
        style={{ height: '50px', cursor: 'pointer', width: '100%' }}
      />
      <div className="text-center mt-2">
          <p style={{marginBottom: '0.5rem'}}><strong>{selectedColor.toUpperCase()}</strong></p>
      </div>
    </>
  );
};

export default ColorPicker;